import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";
import StickyObserver from "./StickyObserver";
import Consent from "./consent/consent";
import { filterManager } from "./components/filterManager/index";
import { casesCarousel } from "./components/casesCarousel";
import DepthTunnelParallax from "./components/parallax";
import arrowUpSvg from "../images/arrow-up.svg?url";
import hashtagSvg from "../images/hashtag.svg?url";
import wordCloud from "./components/wordCloud/index";
import publishingDownload from "./components/publishingDownload";
import trendRadarViewer from "../../modules/trendradar/resources/js/trendradar-viewer";

// Plugins
Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Components
Alpine.data("cookieSettings", Consent.getCookieSettingsComponent());
Alpine.data("filterManager", filterManager);
Alpine.data("wordCloud", wordCloud);
Alpine.data("casesCarousel", casesCarousel);
Alpine.data("publishingDownload", publishingDownload);
Alpine.data("trendRadarViewer", trendRadarViewer);

// Global
window.Alpine = Alpine;

// Inits
Consent.init();

// Initialize Depth Tunnel Parallax
new DepthTunnelParallax();

Alpine.start();

/**
 * Main initialization function for initializing various components on DOMContentLoaded.
 * @returns {void}
 */
function init() {
	initParallax();
	new StickyObserver("#header", "is-sticky-header");
}

/**
 * Initialize SVG Parallax Effect
 * @see ./components/SVGParallax.js
 * @return {Promise<void>}
 */
async function initParallax() {
	const parallaxContainers = document.querySelectorAll(".parallax-container");
	if (parallaxContainers.length > 0) {
		const { default: SVGParallax } =
			await import("./components/SVGParallax");
		for (const container of parallaxContainers) {
			new SVGParallax({
				svgPath: [arrowUpSvg, hashtagSvg],
				seed: 215,
				containerSelector: `#${container.id}`,
				type: SVGParallax.PARALLAX_TYPE_BOTH,
			});
		}
	}
}

document.addEventListener("DOMContentLoaded", init);
